import React from "react";

import { Box, Container, Link, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { CodeSample, MdxLayout } from "@runly/gatsby-theme";

import CtaSection from "../../cta";
import CtaButton from "../../cta/button";
import CtaText from "../../cta/text";
import SectionHead from "../section-head";

import CliExample from "./cli";
import { ReactComponent as ProcessingIcon } from "./processing.svg";
import { ReactComponent as MultiThreadingIcon } from "./multi-threading.svg";
import { ReactComponent as RetryIcon } from "./retry.svg";
import { ReactComponent as DeveloperIcon } from "./developer.svg";

import Javascript from "./javascript.mdx";
import Csharp from "./csharp.mdx";

const CodeSamples = props => {
	const classes = useStyles();

	return (
		<CtaSection backgroundColor="paper">
			<Box clone {...props}>
				<Container maxWidth="lg">
					<SectionHead
						title="Building scalable jobs has never been so easy"
						mb={16}
					>
						Runly jobs are easy to build and easy to scale.{" "}
						<Link href="https://github.com/runlyio/core-dotnet">
							Open source and MIT licensed
						</Link>
						.
					</SectionHead>

					<Grid container spacing={2} alignItems="center" justify="center">
						<Grid item xs={12} md={6}>
							<MdxLayout>
								<CodeSample
									langs={{ csharp: <Csharp />, javascript: <Javascript /> }}
								/>
							</MdxLayout>
						</Grid>

						<Grid item xs={12} md={6}>
							<CliExample />
						</Grid>
					</Grid>

					<Box mt={16}>
						<Grid container spacing={4}>
							<Grid item xs={12} sm={6} md={3}>
								<ProcessingIcon className={classes.art} />

								<CtaText title="Batch processing">
									Process large files, queue and send emails, generate PDFs,
									handle <abbr title="extract, transform, load">ETL</abbr>{" "}
									scenarios, and more. Runly makes it easy to solve common
									problems in software development.
								</CtaText>
							</Grid>

							<Grid item xs={12} sm={6} md={3}>
								<MultiThreadingIcon className={classes.art} />

								<CtaText title="Multi-threading">
									Move heavy workloads to different machines and parallelize
									tasks without changing your code. Set the amount of parallel
									tasks via configuration or from the command line.
								</CtaText>
							</Grid>

							<Grid item xs={12} sm={6} md={3}>
								<RetryIcon className={classes.art} />

								<CtaText title="Retries built-in">
									Build resilient applications that are fault tolerant. Don't
									let intermittent or temporary errors bring down your app's
									critical path.
								</CtaText>
							</Grid>

							<Grid item xs={12} sm={6} md={3}>
								<DeveloperIcon className={classes.art} />

								<CtaText title="Developer friendly">
									Runly is <strong>not a plugin architecture</strong>. Run your
									job app as a CLI and use tools you are already familiar with
									to debug. Get direct, useful results even when code fails.
								</CtaText>
							</Grid>
						</Grid>
					</Box>

					<Box textAlign="center" mt={12}>
						<CtaButton href="/docs/">Build your first job in minutes</CtaButton>
					</Box>
				</Container>
			</Box>
		</CtaSection>
	);
};

const useStyles = makeStyles(theme => ({
	art: {
		display: "block",
		margin: `0 auto ${theme.spacing(4)}px auto`,
		height: 75,
		fill: theme.palette.primary.dark
	}
}));

export default CodeSamples;
